import Vue from 'vue'
import Router from 'vue-router'

// Lazy Loading

const Home = () => System.import('@/components/Home')
const Welcome = () => System.import('@/components/Welcome')
const Login = () => System.import('@/components/Login')
const MapaView = () => System.import('@/components/mapa/Mapa')
const MapaEditView = () => System.import('@/components/mapa_edit/MapaEdit')
const CircuitoList = () => System.import('@/components/circuito/CircuitoList')
const CircuitoEdit = () => System.import('@/components/circuito/CircuitoEdit')

const ComentariosList = () => System.import('@/components/comentarios/ComentariosList')
const ComentariosEdit = () => System.import('@/components/comentarios/ComentariosEdit')

const ComercioList = () => System.import('@/components/comercio/ComercioList')
const ComercioEdit = () => System.import('@/components/comercio/ComercioEdit')

const ComercioVisitaList = () => System.import('@/components/comercio_visita/ComercioVisitaList')
const ReporteVisitaList = () => System.import('@/components/reporte_visita/ReporteVisitaList')

const DepartamentoList = () => System.import('@/components/departamento/DepartamentoList')
const DepartamentoEdit = () => System.import('@/components/departamento/DepartamentoEdit')

const EntidadList = () => System.import('@/components/entidad/EntidadList')
const EntidadEdit = () => System.import('@/components/entidad/EntidadEdit')

const LocalidadList = () => System.import('@/components/localidad/LocalidadList')
const LocalidadEdit = () => System.import('@/components/localidad/LocalidadEdit')

const MarcaList = () => System.import('@/components/marca/MarcaList')
const MarcaEdit = () => System.import('@/components/marca/MarcaEdit')

const MarcaModeloList = () => System.import('@/components/marca_modelo/MarcaModeloList')
const MarcaModeloEdit = () => System.import('@/components/marca_modelo/MarcaModeloEdit')

const PaisList = () => System.import('@/components/pais/PaisList')
const PaisEdit = () => System.import('@/components/pais/PaisEdit')
const PaisDepartamentoList = () => System.import('@/components/pais_departamento/PaisDepartamentoList')
const PaisDepartamentoEdit = () => System.import('@/components/pais_departamento/PaisDepartamentoEdit')
const PaisDepartamentoCiudadList = () => System.import('@/components/pais_departamento_ciudad/PaisDepartamentoCiudadList')
const PaisDepartamentoCiudadEdit = () => System.import('@/components/pais_departamento_ciudad/PaisDepartamentoCiudadEdit')
const PerfilList = () => System.import('@/components/perfil/PerfilList')
const PerfilEdit = () => System.import('@/components/perfil/PerfilEdit')
const RubroList = () => System.import('@/components/rubro/RubroList')
const RubroEdit = () => System.import('@/components/rubro/RubroEdit')
const SegmentoList = () => System.import('@/components/segmento/SegmentoList')
const SegmentoEdit = () => System.import('@/components/segmento/SegmentoEdit')

const UsuarioList = () => System.import('@/components/usuario/UsuarioList')
const UsuarioEdit = () => System.import('@/components/usuario/UsuarioEdit')

const UsuarioDeviceList = () => System.import('@/components/usuario_device/UsuarioDeviceList')

const ZonaList = () => System.import('@/components/zona/ZonaList')
const ZonaEdit = () => System.import('@/components/zona/ZonaEdit')

Vue.use(Router)

const childrenHome = [
  {
    path: '',
    name: 'Welcome',
    component: Welcome,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'mapa-view',
    name: 'MapaView',
    component: MapaView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'mapa_edit-view',
    name: 'MapaEditView',
    component: MapaEditView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'circuito-list',
    name: 'CircuitoList',
    component: CircuitoList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'circuito-edit',
    name: 'CircuitoEdit',
    component: CircuitoEdit,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'comentarios-list',
    name: 'ComentariosList',
    component: ComentariosList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'comentarios-edit',
    name: 'ComentariosEdit',
    component: ComentariosEdit,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'comercio_visita-list',
    name: 'ComercioVisitaList',
    component: ComercioVisitaList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'reporte_visita-list',
    name: 'ReporteVisitaList',
    component: ReporteVisitaList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'comercio-list',
    name: 'ComercioList',
    component: ComercioList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'comercio-edit',
    name: 'ComercioEdit',
    component: ComercioEdit,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'departamento-list',
    name: 'DepartamentoList',
    component: DepartamentoList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'departamento-edit',
    name: 'DepartamentoEdit',
    component: DepartamentoEdit,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'entidad-list',
    name: 'EntidadList',
    component: EntidadList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'entidad-edit',
    name: 'EntidadEdit',
    component: EntidadEdit,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'pais-list',
    name: 'PaisList',
    component: PaisList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'pais-edit',
    name: 'PaisEdit',
    component: PaisEdit,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'pais_departamento-list',
    name: 'PaisDepartamentoList',
    component: PaisDepartamentoList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'pais_departamento-edit',
    name: 'PaisDepartamentoEdit',
    props: true,
    component: PaisDepartamentoEdit,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'pais_departamento_ciudad-list',
    name: 'PaisDepartamentoCiudadList',
    component: PaisDepartamentoCiudadList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'pais_departamento_ciudad-edit',
    name: 'PaisDepartamentoCiudadEdit',
    props: true,
    component: PaisDepartamentoCiudadEdit,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'perfil-list',
    name: 'PerfilList',
    component: PerfilList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'perfil-edit',
    name: 'PerfilEdit',
    component: PerfilEdit,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'rubro-list',
    name: 'RubroList',
    component: RubroList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'rubro-edit',
    name: 'RubroEdit',
    props: true,
    component: RubroEdit,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'localidad-list',
    name: 'LocalidadList',
    component: LocalidadList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'localidad-edit',
    name: 'LocalidadEdit',
    props: true,
    component: LocalidadEdit,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'marca-list',
    name: 'MarcaList',
    component: MarcaList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'marca-edit',
    name: 'MarcaEdit',
    props: true,
    component: MarcaEdit,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'marca_modelo-list',
    name: 'MarcaModeloList',
    component: MarcaModeloList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'marca_modelo-edit',
    name: 'MarcaModeloEdit',
    props: true,
    component: MarcaModeloEdit,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'segmento-list',
    name: 'SegmentoList',
    component: SegmentoList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'segmento-edit',
    name: 'SegmentoEdit',
    component: SegmentoEdit,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'usuario_device-list',
    name: 'UsuarioDeviceList',
    component: UsuarioDeviceList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'usuario-list',
    name: 'UsuarioList',
    component: UsuarioList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'usuario-edit',
    name: 'UsuarioEdit',
    component: UsuarioEdit,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'zona-list',
    name: 'ZonaList',
    component: ZonaList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'zona-edit',
    name: 'ZonaEdit',
    component: ZonaEdit,
    props: true,
    meta: {
      requiresAuth: true
    }
  }
];

const routes = [{
    path: '/',
    // name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true
    },
    children: childrenHome
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  // todas las rutas que no existan.
  {
    path: '*',
    redirect: '/'
  }
];

const router = new Router({ /*mode: 'history',*/ routes: routes })

// const router = new Router({
//   routes: [{
//       path: '/',
//       name: 'Home',
//       component: Home,
//       meta: {
//         requiresAuth: true
//       },
//       children: childrenHome
//     },
//     {
//       path: '/login',
//       name: 'Login',
//       component: Login
//     },
//     {
//       path: '*',
//       redirect: '/'
//     }
//   ]
// })

router.beforeEach((to, from, next) => {
  // check to see if route has auth guard
  if (to.matched.some(rec => rec.meta.requiresAuth)) {
    if (!window.localStorage.getItem('usuario')) {
      next({
        name: 'Login'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js